import { matchPath } from 'react-router';
import { put, select } from 'redux-saga/effects';

import { PATH } from 'constants/RoutesConstants';

import { scopeToPage } from 'modules/app/sagas/utils';
import { fetchVault } from 'modules/lockers/actions';

import { getCurrentLocation } from 'selectors/router';

function* onLockerDetailsPageWorker() {
  const location = yield select(getCurrentLocation);
  const match = matchPath(PATH.KEY_DROP_OFF_LOCKER_DETAILED.path, location);

  yield put(fetchVault({ id: match.params.lockerId, projection: 'details' }));
}

export default function* LockerDetailsSagas() {
  yield scopeToPage([PATH.KEY_DROP_OFF_LOCKER_DETAILED], onLockerDetailsPageWorker);
}
